import { api } from "./apiService";


const GetLeaveTypeList = async () => {
    try {
        const response = await api.get("/LeaveType/GetLeaveType");
        return response;
    } catch (error) {
        console.error("Error fetching leave types:", error);
        throw error;
    }
};

const PostLeaveType = async ({
    typeId,
    typeCode,
    typeName,
    isActive,
    displayOrder,
    typeIsPaid,
    userId,
}) => {
    const params = new URLSearchParams({
        p_typeCode: typeCode,
        p_typeName: typeName,
        p_isActive: isActive,
        p_displayOrder: String(displayOrder),
        p_typeIsPaid: typeIsPaid,
        p_userId: userId,
    });

    if (typeId) {
        params.append('p_typeId', typeId);
    }

    const url = `/LeaveType/PostLeaveType?${params.toString()}`;

    try {
        const response = await api.post(url);
        return response;
    } catch (error) {
        console.error("Error posting leave type:", error);
        throw error;
    }
};

const RequestLeave = async (
    EmpServiceNo,
    FormNo,
    LeaveType,
    FromDate,
    ToDate,
    IsHalfDay,
    HalfDayType,
    Reason,
    ContactNo,
    AttachmentPath,
    UserId
) => {
    // Validate required fields
    const missingFields = [];
    if (!EmpServiceNo) missingFields.push('Employee Service No');
    if (!FormNo) missingFields.push('Form No');
    if (!LeaveType) missingFields.push('Leave Type');
    if (!FromDate) missingFields.push('From Date');
    if (!ToDate) missingFields.push('To Date');
    if (IsHalfDay !== 'Y' && IsHalfDay !== 'N') missingFields.push('IsHalfDay');
    if (IsHalfDay === 'Y' && !HalfDayType) missingFields.push('HalfDayType');
    if (!Reason) missingFields.push('Reason');
    if (!ContactNo) missingFields.push('Contact No');
    if (!UserId) missingFields.push('User ID');

    if (missingFields.length > 0) {
        throw new Error(`Missing required fields: ${missingFields.join(', ')}`);
    }

    const params = new URLSearchParams({
        p_empServiceNo: EmpServiceNo,
        p_formNo: FormNo,
        p_leaveType: LeaveType,
        p_fromDate: FromDate,
        p_toDate: ToDate,
        p_isHalfDay: IsHalfDay,
        p_HalfDayType: HalfDayType,
        p_reason: Reason,
        p_contactNo: ContactNo,
        p_userId: UserId
    });

    const url = `/LeaveApprovels/RequsetLeave?${params.toString()}`;

    const body = {
        p_attachmentPath: AttachmentPath || ''
    };

    try {
        const response = await api.post(url, body);
        return response;
    } catch (error) {
        console.error("Error submitting leave request:", error);
        throw error;
    }
};

const GetLeavesRequestByStatus = async (LeaveStatus) => {
    if (!LeaveStatus) {
        throw new Error('Leave status is required');
    }

    const params = new URLSearchParams({
        p_leaveStatus: LeaveStatus,
    });

    const url = `/LeaveApprovels/GetAllRequestLeaveList?${params.toString()}`;

    try {
        const response = await api.get(url);
        return response;
    } catch (error) {
        console.error("Error fetching leaves by status:", error);
        throw error;
    }
};

const GetLeaveDetailsByUser = async (EmpServiceNo) => {
    if (!EmpServiceNo) {
        throw new Error('Employee service number is required');
    }

    const params = new URLSearchParams({
        p_empServiceNo: EmpServiceNo,
    });

    const url = `/LeaveApprovels/GetLeaveListByUserId?${params.toString()}`;

    try {
        const response = await api.get(url);
        return response;
    } catch (error) {
        console.error("Error fetching leave details:", error);
        throw error;
    }
};

const AcceptLeave = async (LeaveFormId, FormNo, UserId, Reason) => {
    if (!LeaveFormId || !FormNo || !UserId) {
        throw new Error('Leave Form ID, Form No, and User ID are required');
    }

    const params = new URLSearchParams({
        p_leaveFormId: LeaveFormId,
        p_formNo: FormNo,
        p_userId: UserId,
        p_reason: Reason || ''
    });

    const url = `/LeaveApprovels/LeaveApprovels?${params.toString()}`;

    try {
        const response = await api.post(url);
        return response;
    } catch (error) {
        console.error("Error accepting leave:", error);
        throw error;
    }
};

const RejectLeave = async (LeaveFormId, FormNo, UserId, Reason) => {
    if (!LeaveFormId || !FormNo || !UserId) {
        throw new Error('Leave Form ID, Form No, and User ID are required');
    }

    const params = new URLSearchParams({
        p_leaveFormId: LeaveFormId,
        p_formNo: FormNo,
        p_userId: UserId,
        p_reason: Reason || ''
    });

    const url = `/LeaveApprovels/LeaveReject?${params.toString()}`;

    try {
        const response = await api.post(url);
        return response;
    } catch (error) {
        console.error("Error rejecting leave:", error);
        throw error;
    }
};

const CancelLeave = async (LeaveFormId, FormNo, UserId) => {
    if (!LeaveFormId || !FormNo || !UserId) {
        throw new Error('Leave Form ID, Form No, and User ID are required');
    }

    const params = new URLSearchParams({
        p_leaveFormId: LeaveFormId,
        p_formNo: FormNo,
        p_userId: UserId
    });

    const url = `/LeaveApprovels/LeaveCancelation?${params.toString()}`;

    try {
        const response = await api.post(url);
        return response;
    } catch (error) {
        console.error("Error canceling leave:", error);
        throw error;
    }
};

const GetEmpLeaveAllocation = async (EmpServiceNo) => {
    if (!EmpServiceNo) {
        throw new Error('Employee service number is required');
    }

    const params = new URLSearchParams({
        p_empServiceNo: EmpServiceNo,
    });

    const url = `/EmpLeaveAllocation/GetEmpLeaveAllocation?${params.toString()}`;

    try {
        const response = await api.get(url);
        return response;
    } catch (error) {
        console.error("Error fetching employee leave allocation:", error);
        throw error;
    }
};


const GetEmpLeaveSummary = async () => {
    try {
        const response = await api.get("/EmpLeaveAllocation/GetEmpLeaveSummery");
        return response;
    } catch (error) {
        console.error("Error fetching employee leave summary:", error);
        throw error;
    }
};


const leaveService = {
    RejectLeave,
    GetLeaveTypeList,
    AcceptLeave,
    RequestLeave,
    PostLeaveType,
    CancelLeave,
    GetLeaveDetailsByUser,
    GetLeavesRequestByStatus,
    GetEmpLeaveAllocation,
    GetEmpLeaveSummary,
};

export default leaveService;